import { usePostProbeLotApi, usePutProbeLotApi } from 'api/probe_lot'
import { DateField, InputField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { ProbeLot, ProbeLotForm } from 'entities/probe_lot'

const FormView = (form: Form<ProbeLot>, apiError: ApiError) => {
    return (
        <>
            <DateField apiError={apiError} form={form} attr={'date'} label="Date" required />
            <InputField apiError={apiError} form={form} attr={'number'} label="Number" required />
            <InputField apiError={apiError} form={form} attr={'note'} label="Note" as="textarea" />
        </>
    )
}

type NewProbeLotFormProps = {
    onComplete?: () => void
    probeId?: number
}

export const NewProbeLotForm = (props: NewProbeLotFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostProbeLotApi()
    const form = useForm<ProbeLotForm>({ probeId: props.probeId })
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                新規登録
            </Button>
            <Modal show={show} onHide={handleClose} size="sm">
                <Modal.Header closeButton>
                    <Modal.Title>ProbeLotの登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>{FormView(form, api.apiError)}</>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

type EditProbeLotFormProps = {
    probeLot: ProbeLot
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditProbeLotForm = (props: EditProbeLotFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutProbeLotApi()
    const form = useForm<ProbeLotForm>(props.probeLot)

    useEffectSkipFirst(() => {
        form.set(props.probeLot)
    }, [props.probeLot])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal show={props.show} onHide={props.onClose} size="sm">
            <Modal.Header closeButton>
                <Modal.Title>ProbeLotの編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {form.object.id && (
                    <>
                        <h3 style={{ marginBottom: 10 }}>Lot{props.probeLot.number}</h3>
                        {FormView(form, api.apiError)}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
